import React, { useEffect, useState } from "react";
import authorized from "./Images/authorized.png";
import authorizedFastwyre from "./Images/authorizedFastwyre.png";
import { Modal, TextField } from "@mui/material";
import { IoCloseCircle, IoTimeOutline } from "react-icons/io5";
import FiberPlanSelector from "../../../../../components/FiberPlanSelector";
import Swal from "sweetalert2";
import UpdateCustomerInstallDateReq from "../../../../../Requests/Customer/UpdateCustomerInstallDateReq";
import CustomerApi from "../../../../../API/CustomerApi";
import CreateRescheduleFormReq from "../../../../../Requests/Customer/CreateRescheduleFormReq";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const ScheduleForm = ({
  open,
  setOpen,
  lead,
  fidiumCustomer,
  setReload,
  fiberCompany,
  setOpenReasonModal,
  fiberHouse,
  skipStep,
  setSkipStep,
}) => {
  const [rescheduleFrom, setRescheduleFrom] = useState("");
  const [secondReference, setSecondReference] = useState("");
  const [installTimeFrom, setInstallTimeFrom] = useState("");
  const [installTimeTo, setInstallTimeTo] = useState("");
  const [selectedTimeRange, setSelectedTimeRange] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [promoCodeRadio, setPromoCodeRadio] = useState("");
  const [installPlan, setInstalltPlan] = useState(fidiumCustomer?.fiberPlanId);
  const [accountNumber, setAccountNumber] = useState("");
  const [slotSeledcted, setSlotSelected] = useState("");
  const [notes, setNotes] = useState("");
  const [daySelected, setDaySelected] = useState("");
  const [paymentInfoCollected, setPaymentInfoCollected] = useState(false);
  const [uploadBooster, setUploadBooster] = useState(
    fidiumCustomer?.uploadBooster
  );
  const daysOut = fiberCompany?.daysOut ?? 4;

  const filterMinutes = (date) => {
    if (!date) return null; // Prevents invalid date error
    const minutes = date.getMinutes();
    if (![0, 15, 30, 45].includes(minutes)) {
      date.setMinutes(Math.round(minutes / 15) * 15);
    }
    return new Date(date); // Ensures a Date object is returned
  };

  // console.log("reason", lead?.fidiumCustomer?.reasonToSkipSchedule);
  const formatDateToISOString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

    // Concatenate without timezone offset
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
  };
  const updateInstallDate = async () => {
    Swal.fire({
      icon: "info",
      title: "Please Wait",
      text: "Updating Install Date",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      showCancelButton: false,
      customClass: {
        container: "custom-swal",
      },
      willOpen: () => {
        Swal.showLoading();
      },
    });

    // the day should be the same in the install date and install date to and the time in the install date should be less than the time in the install date to
    if (!rescheduleFrom) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select Install Date",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    if (!installTimeFrom || !installTimeTo) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select Install Time",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    if (!installPlan) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select a plan",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    if (
      fidiumCustomer?.fiberCompanyId === 2 &&
      uploadBooster === null &&
      lead.leadType === "HFC Plus"
    ) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select if upload booster was applied",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    if (
      fidiumCustomer?.fiberCompanyId === 10 ||
      fidiumCustomer?.fiberCompanyId === 11
    ) {
      if (!accountNumber) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Please Enter Subscriber ID",
          customClass: {
            container: "custom-swal",
          },
          didOpen: () => {
            Swal.hideLoading();
          },
        });
        return;
      }
    }

    const req = new UpdateCustomerInstallDateReq();
    req.customerId = fidiumCustomer.id;
    const [year, month, day] = rescheduleFrom.split("-").map(Number);

    let secondPreference = null;

    if (secondReference) {
      const [year2, month2, day2] = secondReference.split("-").map(Number);
      secondPreference = new Date(year2, month2 - 1, day2);

      let second = formatDateToISOString(
        new Date(
          secondPreference.setHours(
            installTimeFrom.getHours(), // ✅ Fix
            installTimeFrom.getMinutes() // ✅ Fix
          )
        )
      );
      req.installDateTimeSecondPrefrence = second;
    }

    // Create a new date object with the desired year, month, and day
    const installDate = new Date(year, month - 1, day);
    let from = formatDateToISOString(
      new Date(
        installDate.setHours(
          installTimeFrom.getHours(), // ✅ Correct way to get hours
          installTimeFrom.getMinutes() // ✅ Correct way to get minutes
        )
      )
    );
    let to = formatDateToISOString(
      new Date(
        installDate.setHours(
          installTimeTo.getHours(), // ✅ Correct way to get hours
          installTimeTo.getMinutes() // ✅ Correct way to get minutes
        )
      )
    );

    req.installDateTime = from;
    req.installDateTimeTo = to;
    req.promo = promoCode + "\n" + promoCodeRadio;
    req.promo = req.promo.trim("\n");
    req.paymentInfoCollected = paymentInfoCollected;
    req.accountNumber = accountNumber;
    req.uploadBooster = uploadBooster;
    const res = await CustomerApi.EditCustomerInstallDate(req);
    if (res?.status?.success) {
      const newStep = {
        id: null,
        mapIconId: null,
        step: null,
      };
      // setSkipStep(newStep);
      // localStorage.setItem("skipStep", JSON.stringify(newStep));
      // console.log("Saved to localStorage:", newStep);

      setOpen(false);

      if (
        fidiumCustomer.fiberCompanyId === 15 &&
        req.promo.includes("Free Month")
      ) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "The Free Month has been Submitted and will be Applied on the Customer's First Billing Payment",
          willClose: () => {
            Swal.hideLoading();
          },
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Install Date Updated Successfully",
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: "Close",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            container: "custom-swal",
          },
          willClose: () => {
            Swal.hideLoading();
          },
        });
      }

      setReload((prev) => {
        return !prev;
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res?.status?.message,
      });
    }
  };

  const submitReschedule = async () => {
    setOpen(false);
    Swal.fire({
      icon: "info",
      title: "Please Wait",
      text: "Submitting Reschedule Request",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      showCancelButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    if (!rescheduleFrom && !daySelected) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select Install Date Or Day",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    if (!installTimeFrom || !installTimeTo) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select Install Time",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    if (!lead?.fidiumCustomer) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "There is no customer associated with this lead",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    const req = new CreateRescheduleFormReq();
    req.FidiumCustomerId = fidiumCustomer.id;
    console.log(rescheduleFrom);
    const [year, month, day] = rescheduleFrom.split("-").map(Number);
    if (daySelected) {
      req.rescheduleDay = daySelected;
    }

    // Create a new date object with the desired year, month, and day
    const installDate = new Date(year, month - 1, day);

    // resshcedule from should be atleast 7 days from the current date
    const minDate = new Date();
    minDate.setDate(
      minDate.getDate() + (fidiumCustomer?.fiberCompanyId === 9 ? 13 : 6)
    );
    let selectedFromDate = new Date(
      installDate.setHours(
        installTimeFrom.getHours(), // ✅ Get hours from Date object
        installTimeFrom.getHours(), // ✅ Get hours from Date object
        installTimeFrom.getMinutes() // ✅ Get minutes from Date object
      )
    );

    if (selectedFromDate < minDate) {
      Swal.fire({
        icon: "error",
        title: "Invalid Date",
        text: `Please select a date that is at least ${
          fidiumCustomer?.fiberCompanyId === 9 ? 14 : 7
        } days from today.`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    let from = formatDateToISOString(
      new Date(
        installDate.setHours(
          installTimeFrom.getHours(), // ✅ Get hours from Date object
          installTimeFrom.getMinutes() // ✅ Get minutes from Date object
        )
      )
    );

    let to = formatDateToISOString(
      new Date(
        installDate.setHours(
          installTimeTo.getHours(), // ✅ Get hours from Date object
          installTimeTo.getMinutes() // ✅ Get minutes from Date object
        )
      )
    );
    if (!daySelected) {
      req.NewInstallDate = from;
      req.NewInstallDateTo = to;
    }
    req.notes = notes;
    const res = await CustomerApi.RescheduleForm(req);
    if (res?.status?.success) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Reschedule Request Submitted Successfully",
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: "Close",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        customClass: {
          container: "custom-swal",
        },
        willClose: () => {
          Swal.hideLoading();
        },
      });
      setReload((prev) => {
        return !prev;
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res?.status?.message,
      });
    }
  };

  const getMinDate = () => {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 7);
    return minDate.toISOString().split("T")[0];
  };

  const minDateToday = () => {
    const minDate = new Date();
    return minDate.toISOString().split("T")[0];
  };

  return (
    <Modal
      setOpen={setOpen}
      open={open}
      onClose={() => {
        // if (
        //   lead?.fidiumCustomer?.installDateTime
        // || lead?.fidiumCustomer?.reasonToSkipSchedule
        // ) {
        setOpen(false);
        // }
      }}
    >
      {lead?.fidiumCustomer?.installDateTime ? (
        <div
          style={{
            justifyContent: "initial",
          }}
          className="custom_modal"
        >
          <IoCloseCircle
            onClick={() => {
              setOpen(false);
            }}
            size={30}
            style={{ marginLeft: "auto", cursor: "pointer" }}
            color="#2761d0"
          />
          {fidiumCustomer?.fiberCompanyId === 2 && (
            <img alt="Logo" src={authorized} className="logo" />
          )}
          {fidiumCustomer?.fiberCompanyId === 9 && (
            <img alt="Logo" src={authorizedFastwyre} className="logo" />
          )}
          {(fidiumCustomer?.fiberCompanyId === 10 ||
            fidiumCustomer?.fiberCompanyId === 11) && (
            <img
              src="/images/offer/pointbroadband/logo.png"
              alt="Authorized Point Broadband"
            />
          )}

          {fidiumCustomer?.fiberCompanyId === 12 && (
            <img src="/images/offer/wyyerd/logo.png" alt="Wyyerd Contractor" />
          )}
          {fidiumCustomer?.fiberCompanyId === 13 && (
            <img
              src="/images/offer/astound/logo.png"
              alt="Authorized Point Broadband"
            />
          )}
          {fidiumCustomer?.fiberCompanyId === 14 && (
            <img
              src="/images/offer/sonic/logo.png"
              alt="Authorized Point Broadband"
            />
          )}
          {fidiumCustomer?.fiberCompanyId === 15 && (
            <img
              style={{ width: "250px" }}
              src="/images/offer/ezee/ezeelogo.png"
              alt="Authorized Point Broadband"
            />
          )}

          {/* <h1 >Install Date Time</h1> */}
          <label>Reschedule Date</label>
          {/* <input
            type="date"
            value={rescheduleFrom}
            onChange={(e) => {
              setDaySelected("");
              setRescheduleFrom(e.target.value);
            }}

          /> */}
          <TextField
            type="date"
            value={rescheduleFrom}
            // min={getMinDate()}
            // disabled={daySelected}
            onChange={(e) => {
              setDaySelected("");
              setRescheduleFrom(e.target.value);
            }}
            min={
              new Date(Date.now() + 86400000 * daysOut)
                .toISOString()
                .split("T")[0]
            }
          />

          {fidiumCustomer?.fiberCompanyId === 10 ||
          fidiumCustomer?.fiberCompanyId === 11 ? (
            <>
              <p className="or">OR</p>
              <label>Select Available Days</label>
              <div className="grid grid-cols-2 gap-2 w-full">
                {[
                  "Next Available",
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday",
                ].map((day, index) => {
                  return (
                    <p
                      onClick={() => {
                        setDaySelected(day);
                        setRescheduleFrom("");
                      }}
                      key={index}
                      className={`p-2 rounded-lg border-4 cursor-pointer ${
                        daySelected === day
                          ? "border-[#2761d0] text-[#2761d0]"
                          : ""
                      } w-full text-center`}
                    >
                      {day}
                    </p>
                  );
                })}
              </div>
              <label>Intall Time Slot:</label>
              <div className="grid grid-cols-2 gap-2 w-full">
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(8, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(10, 0, 0, 0))
                    );
                    setSelectedTimeRange("8-10");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "8-10"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  8:00am - 10:00am
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(10, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(12, 0, 0, 0))
                    );
                    setSelectedTimeRange("10-12");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "10-12"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  10:00am - 12:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(12, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(14, 0, 0, 0))
                    );
                    setSelectedTimeRange("12-2");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "12-2"
                      ? "border-[#2761d0] font-bold text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  12:00pm - 2:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(14, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(16, 0, 0, 0))
                    );
                    setSelectedTimeRange("2-4");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "2-4"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  2:00pm - 4:00pm
                </p>
              </div>
            </>
          ) : fidiumCustomer?.fiberCompanyId === 13 ? (
            <>
              <label>Intall Time Slot:</label>
              <div className="grid grid-cols-2 gap-2 w-full">
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(8, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(10, 0, 0, 0))
                    );
                    setSelectedTimeRange("8-10");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "8-10"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  8:00am - 10:00am
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(8, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(12, 0, 0, 0))
                    );
                    setSelectedTimeRange("8-12");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "8-12"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  8:00am - 12:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(10, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(12, 0, 0, 0))
                    );
                    setSelectedTimeRange("10-12");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "10-12"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  10:00am - 12:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(13, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(15, 0, 0, 0))
                    );
                    setSelectedTimeRange("1-3");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "1-3"
                      ? "border-[#2761d0] font-bold text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  1:00pm - 3:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(15, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(17, 0, 0, 0))
                    );
                    setSelectedTimeRange("3-5");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "3-5"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  3:00pm - 5:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(17, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(19, 0, 0, 0))
                    );
                    setSelectedTimeRange("5-7");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "5-7"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  5:00pm - 7:00pm
                </p>
              </div>
            </>
          ) : fidiumCustomer?.fiberCompanyId === 15 ? (
            <>
              <div className="grid grid-cols-2 gap-2 w-full">
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(8, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(10, 0, 0, 0))
                    );
                    setSelectedTimeRange("8-10");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "8-10"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  8:00am - 10:00am
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(10, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(12, 0, 0, 0))
                    );
                    setSelectedTimeRange("10-12");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "10-12"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  10:00am - 12:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(13, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(15, 0, 0, 0))
                    );
                    setSelectedTimeRange("1-3");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "1-3"
                      ? "border-[#2761d0] font-bold text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  1:00pm - 3:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(15, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(17, 0, 0, 0))
                    );
                    setSelectedTimeRange("3-5");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "3-5"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  3:00pm - 5:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(17, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(19, 0, 0, 0))
                    );
                    setSelectedTimeRange("5-7");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "5-7"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  5:00pm - 7:00pm
                </p>
              </div>
            </>
          ) : (
            <>
              <label>Intall Time Slot:</label>
              <div className="time_slot">
                <DatePicker
                  selected={installTimeFrom}
                  onChange={(date) => setInstallTimeFrom(filterMinutes(date))}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15} // Ensures only 0, 15, 30, 45 are selectable
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                  placeholderText="Select Time"
                />
                <p>To</p>
                <DatePicker
                  selected={installTimeTo}
                  onChange={(date) => setInstallTimeTo(filterMinutes(date))}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                  placeholderText="Select time"
                />
              </div>
              <p className="or">OR</p>
              <div className="am_pm">
                <p
                  onClick={() => {
                    setSelectedTimeRange("AM");
                    setInstallTimeFrom(
                      new Date(new Date().setHours(8, 0, 0, 0))
                    ); // Correct
                    setInstallTimeTo(
                      new Date(new Date().setHours(12, 0, 0, 0))
                    ); // Correct
                  }}
                  className={`${selectedTimeRange === "AM" ? "active" : ""}`}
                >
                  AM
                  <br />
                  <span className="text-xs">8:00am - 12:00pm</span>
                </p>
                <p
                  onClick={() => {
                    setSelectedTimeRange("PM");
                    setInstallTimeFrom(
                      new Date(new Date().setHours(12, 0, 0, 0))
                    ); // Correct
                    setInstallTimeTo(
                      new Date(new Date().setHours(16, 0, 0, 0))
                    ); // Correct
                  }}
                  className={`${selectedTimeRange === "PM" ? "active" : ""}`}
                >
                  PM
                  <br />
                  <span className="text-xs">12:00pm - 4:00pm</span>
                </p>
              </div>
            </>
          )}

          <div className="mt-4 w-full border-2 p-2 border-gray-200 rounded-lg ">
            <div className="flex justify-between items-center ">
              <h3 className="font-bold text-gray-700">Notes</h3>
            </div>
            <div className="mt-2 w-full relative rounded-lg p-2 border-gray-200 h-24 ">
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                className="w-full h-full border-none focus:outline-none outline-none"
                placeholder="Type your notes here..."
              ></textarea>
            </div>
          </div>
          <button
            onClick={() => {
              submitReschedule();
            }}
          >
            SUBMIT RESCHEDULE REQUEST
          </button>
          {fidiumCustomer?.fiberCompanyId !== 15 && (
            <img alt="Logo" src={"/images/nav/nav-logo.png"} className="logo" />
          )}
        </div>
      ) : (
        <div
          style={{
            justifyContent: "initial",
          }}
          className="custom_modal"
        >
          <div className="flex items-center justify-end w-full">
            {/* {lead?.fidiumCustomer?.reasonToSkipSchedule && ( */}
            <IoCloseCircle
              onClick={() => {
                setOpen(false);
              }}
              size={30}
              style={{ marginLeft: "auto", cursor: "pointer" }}
              color="#2761d0"
            />
            {/* )} */}
          </div>
          <div className="h-[200px]">
            {fidiumCustomer?.fiberCompanyId === 2 && (
              <img alt="Logo" src={authorized} className="logo" />
            )}
            {fidiumCustomer?.fiberCompanyId === 9 && (
              <img alt="Logo" src={authorizedFastwyre} className="logo" />
            )}
            {(fidiumCustomer?.fiberCompanyId === 10 ||
              fidiumCustomer?.fiberCompanyId === 11) && (
              <img
                src="/images/offer/pointbroadband/logo.png"
                alt="Authorized Point Broadband"
              />
            )}

            {fidiumCustomer?.fiberCompanyId === 12 && (
              <img
                src="/images/offer/wyyerd/logo.png"
                alt="Wyyerd Contractor"
              />
            )}

            {fidiumCustomer?.fiberCompanyId === 13 && (
              <img
                src="/images/offer/astound/logo.png"
                alt="Authorized Point Broadband"
              />
            )}
            {fidiumCustomer?.fiberCompanyId === 14 && (
              <img
                src="/images/offer/sonic/logo.png"
                alt="Authorized Point Broadband"
              />
            )}
            {fidiumCustomer?.fiberCompanyId === 15 && (
              <img
                style={{ width: "250px" }}
                src="/images/offer/ezee/ezeelogo.png"
                alt="Authorized Point Broadband"
              />
            )}
          </div>
          {/* <p>
            after completing {lead?.fidiumCustomer?.fiberCompany?.name} order
            process input install date and time
          </p> */}
          {/* <h1 >Install Date Time</h1> */}
          {fidiumCustomer?.fiberCompanyId === 10 ||
          fidiumCustomer?.fiberCompanyId === 11 ? (
            // false?
            <>
              <label>First Preference Install Date</label>
              <TextField
                type="date"
                className="w-full"
                value={rescheduleFrom}
                min={minDateToday()}
                onChange={(e) => {
                  setRescheduleFrom(e.target.value);
                }}
              />
              <label>Second Preference Install Date (Optional)</label>
              <TextField
                type="date"
                value={secondReference}
                min={minDateToday()}
                onChange={(e) => {
                  setSecondReference(e.target.value);
                }}
              />
            </>
          ) : (
            <>
              <label>Install Date</label>
              <TextField
                type="date"
                value={rescheduleFrom}
                onChange={(e) => {
                  setRescheduleFrom(e.target.value);
                }}
                min={minDateToday()}
              />
            </>
          )}

          <label>Intall Time Slot:</label>

          {fidiumCustomer?.fiberCompanyId === 10 ||
          fidiumCustomer?.fiberCompanyId === 11 ? (
            <div className="grid grid-cols-2 gap-2 w-full">
              <p
                onClick={() => {
                  setInstallTimeFrom(new Date(new Date().setHours(8, 0, 0, 0)));
                  setInstallTimeTo(new Date(new Date().setHours(10, 0, 0, 0)));
                  setSelectedTimeRange("8-10");
                }}
                className={`p-2 rounded-lg border-4 cursor-pointer  ${
                  selectedTimeRange === "8-10"
                    ? "border-[#2761d0] text-[#2761d0]"
                    : ""
                } w-full text-center`}
              >
                8:00am - 10:00am
              </p>
              <p
                onClick={() => {
                  setInstallTimeFrom(
                    new Date(new Date().setHours(10, 0, 0, 0))
                  );
                  setInstallTimeTo(new Date(new Date().setHours(12, 0, 0, 0)));
                  setSelectedTimeRange("10-12");
                }}
                className={`p-2 rounded-lg border-4 cursor-pointer ${
                  selectedTimeRange === "10-12"
                    ? "border-[#2761d0] text-[#2761d0]"
                    : ""
                } w-full text-center`}
              >
                10:00am - 12:00pm
              </p>
              <p
                onClick={() => {
                  setInstallTimeFrom(
                    new Date(new Date().setHours(12, 0, 0, 0))
                  );
                  setInstallTimeTo(new Date(new Date().setHours(14, 0, 0, 0)));
                  setSelectedTimeRange("12-2");
                }}
                className={`p-2 rounded-lg border-4 cursor-pointer ${
                  selectedTimeRange === "12-2"
                    ? "border-[#2761d0] font-bold text-[#2761d0]"
                    : ""
                } w-full text-center`}
              >
                12:00pm - 2:00pm
              </p>
              <p
                onClick={() => {
                  setInstallTimeFrom(
                    new Date(new Date().setHours(14, 0, 0, 0))
                  );
                  setInstallTimeTo(new Date(new Date().setHours(16, 0, 0, 0)));
                  setSelectedTimeRange("2-4");
                }}
                className={`p-2 rounded-lg border-4 cursor-pointer  ${
                  selectedTimeRange === "2-4"
                    ? "border-[#2761d0] text-[#2761d0]"
                    : ""
                } w-full text-center`}
              >
                2:00pm - 4:00pm
              </p>
            </div>
          ) : fidiumCustomer?.fiberCompanyId === 13 ? (
            <>
              <div className="grid grid-cols-2 gap-2 w-full">
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(8, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(10, 0, 0, 0))
                    );
                    setSelectedTimeRange("8-10");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "8-10"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  8:00am - 10:00am
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(8, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(12, 0, 0, 0))
                    );
                    setSelectedTimeRange("8-12");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "8-12"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  8:00am - 12:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(10, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(12, 0, 0, 0))
                    );
                    setSelectedTimeRange("10-12");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "10-12"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  10:00am - 12:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(13, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(15, 0, 0, 0))
                    );
                    setSelectedTimeRange("1-3");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "1-3"
                      ? "border-[#2761d0] font-bold text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  1:00pm - 3:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(15, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(17, 0, 0, 0))
                    );
                    setSelectedTimeRange("3-5");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "3-5"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  3:00pm - 5:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(17, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(19, 0, 0, 0))
                    );
                    setSelectedTimeRange("5-7");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "5-7"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  5:00pm - 7:00pm
                </p>
              </div>
            </>
          ) : fidiumCustomer?.fiberCompanyId === 15 ? (
            <>
              <div className="grid grid-cols-2 gap-2 w-full">
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(8, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(10, 0, 0, 0))
                    );
                    setSelectedTimeRange("8-10");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "8-10"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  8:00am - 10:00am
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(10, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(12, 0, 0, 0))
                    );
                    setSelectedTimeRange("10-12");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "10-12"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  10:00am - 12:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(13, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(15, 0, 0, 0))
                    );
                    setSelectedTimeRange("1-3");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer ${
                    selectedTimeRange === "1-3"
                      ? "border-[#2761d0] font-bold text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  1:00pm - 3:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(15, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(17, 0, 0, 0))
                    );
                    setSelectedTimeRange("3-5");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "3-5"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  3:00pm - 5:00pm
                </p>
                <p
                  onClick={() => {
                    setInstallTimeFrom(
                      new Date(new Date().setHours(17, 0, 0, 0))
                    );
                    setInstallTimeTo(
                      new Date(new Date().setHours(19, 0, 0, 0))
                    );
                    setSelectedTimeRange("5-7");
                  }}
                  className={`p-2 rounded-lg border-4 cursor-pointer  ${
                    selectedTimeRange === "5-7"
                      ? "border-[#2761d0] text-[#2761d0]"
                      : ""
                  } w-full text-center`}
                >
                  5:00pm - 7:00pm
                </p>
              </div>
            </>
          ) : (
            <div className="time_slot">
              <DatePicker
                selected={installTimeFrom}
                onChange={(date) => setInstallTimeFrom(filterMinutes(date))}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15} // Ensures only 0, 15, 30, 45 are selectable
                timeCaption="Time"
                dateFormat="h:mm aa"
                placeholderText="Select Time"
              />
              <p>To</p>
              <DatePicker
                selected={installTimeTo}
                onChange={(date) => setInstallTimeTo(filterMinutes(date))}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="h:mm aa"
                placeholderText="Select time"
              />
            </div>
          )}

          {fidiumCustomer?.fiberCompanyId !== 10 &&
            fidiumCustomer?.fiberCompanyId !== 11 &&
            fidiumCustomer?.fiberCompanyId !== 13 &&
            fidiumCustomer?.fiberCompanyId !== 15 && (
              <>
                <p className="or">OR</p>
                <div className="am_pm">
                  <p
                    onClick={() => {
                      setSelectedTimeRange("AM");
                      setInstallTimeFrom(
                        new Date(new Date().setHours(8, 0, 0, 0))
                      ); // Correct
                      setInstallTimeTo(
                        new Date(new Date().setHours(12, 0, 0, 0))
                      ); // Correct
                    }}
                    className={`${selectedTimeRange === "AM" ? "active" : ""}`}
                  >
                    AM
                    <br />
                    <span className="text-xs">8:00am - 12:00pm</span>
                  </p>
                  <p
                    onClick={() => {
                      setSelectedTimeRange("PM");
                      setInstallTimeFrom(
                        new Date(new Date().setHours(12, 0, 0, 0))
                      ); // Correct
                      setInstallTimeTo(
                        new Date(new Date().setHours(16, 0, 0, 0))
                      ); // Correct
                    }}
                    className={`${selectedTimeRange === "PM" ? "active" : ""}`}
                  >
                    PM
                    <br />
                    <span className="text-xs">12:00pm - 4:00pm</span>
                  </p>
                </div>
              </>
            )}
          {/* <FiberCompanySelector setUser={setInstallCompany} disabled={false} placeholder="Select a Company" className="fiber_company_selector" /> */}
          <FiberPlanSelector
            fiberPlan={fidiumCustomer?.fiberPlan}
            setUser={setInstalltPlan}
            placeholder="Select a Plan"
            className="fiber_company_selector"
            fiberCompany={fidiumCustomer?.fiberCompanyId}
          />

          {(fidiumCustomer?.fiberCompanyId === 10 ||
            fidiumCustomer?.fiberCompanyId === 11) && (
            <>
              <label>Subscriber Id</label>
              <input
                type="text"
                value={accountNumber}
                onChange={(e) => {
                  setAccountNumber(e.target.value);
                }}
              />
            </>
          )}

          <div className="flex items-center justify-start gap-2 w-full">
            <input
              type="checkbox"
              style={{
                width: "fit-content",
              }}
              checked={paymentInfoCollected}
              onChange={(e) => {
                setPaymentInfoCollected(e.target.checked);
              }}
            />
            <label>PAYMENT INFO COLLECTED</label>
          </div>
          <div className="promos" style={{ width: "100%" }}>
            <p>Promos</p>
            <div className="promo_options">
            {fidiumCustomer?.fiberCompany?.offerTemplates?.length > 0
                    ? fidiumCustomer?.fiberCompany?.offerTemplates[0].promos
                        .split("\n")
                        .map((promoGroup, index) => {
                          return (
                            <div key={index}>
                              {promoGroup.split('"').map((promo, subIndex) => {
                                if (promo.trim() === "") return null;
                                if (promoGroup.includes('"')) {
                                  return (
                                    <label
                                      className="promo"
                                      htmlFor={`free${index}-${subIndex}`}
                                      key={subIndex}
                                    >
                                      <input
                                        type="radio"
                                        id={`free${index}-${subIndex}`}
                                        name="promo"
                                        onChange={() => setPromoCodeRadio(promo)}
                                      />
                                      <span>{promo}</span>
                                    </label>
                                  );
                                } else {
                                  return (
                                    <label
                                      className="promo"
                                      htmlFor={`free${index}-${subIndex}`}
                                      key={subIndex}
                                    >
                                      <input
                                        type="checkbox"
                                        id={`free${index}-${subIndex}`}
                                        name={`free${index}-${subIndex}`}
                                        onChange={(e) => {
                                          if (promoCode) {
                                              let arr = promoCode.split('\n');
                                              if (arr.includes(promo)) {
                                                  arr = arr.filter((item) => item !== promo);
                                                  setPromoCode(arr.join('\n'));
                                              } else {
                                                setPromoCode((prev) => (prev ? prev + '\n' + promo : promo));
                                              }
                                          } else {
                                          setPromoCode(promo);
                                          }
                                        }}
                                      />
                                      <span>{promo}</span>
                                    </label>
                                  );
                                }
                              })}
                            </div>
                          );
                        })
                    : null}
            </div>
          </div>
          {lead.leadType === "HFC Plus" &&
            fidiumCustomer?.fiberCompanyId === 2 && (
              <div className="w-full">
                <h4 className="text-lg font-bold">Upload Booster</h4>
                <div className="flex items-center justify-start gap-8">
                  {/* radio button yes or no */}
                  <div className="flex items-center justify-start gap-2">
                    <input
                      type="radio"
                      name="uploadBooster"
                      id="yes"
                      value="yes"
                      checked={uploadBooster === true}
                      onChange={() => {
                        setUploadBooster(true);
                      }}
                    />
                    <label className="text-base" htmlFor="yes">
                      Yes
                    </label>
                  </div>
                  <div className="flex items-center justify-start gap-2">
                    <input
                      type="radio"
                      name="uploadBooster"
                      id="no"
                      value="no"
                      checked={uploadBooster === false}
                      onChange={() => {
                        setUploadBooster(false);
                      }}
                    />
                    <label className="text-base" htmlFor="no">
                      No
                    </label>
                  </div>
                </div>
              </div>
            )}
          <div className="flex items-center w-full">
            <button
              onClick={() => {
                updateInstallDate();
              }}
            >
              SCHEDULE INSTALL
            </button>
          </div>
          {/* {!lead?.fidiumCustomer?.reasonToSkipSchedule && (
            <div className="flex items-center w-full">
              <p
                onClick={() => {
                  const newStep = {
                    id: fiberHouse?.id,
                    mapIconId: fiberHouse?.mapIconId,
                    step: 3,
                  };
                  setSkipStep(newStep);
                  localStorage.setItem("skipStep", JSON.stringify(newStep));
                  console.log("Saved to localStorage:", newStep);
                  setOpen(false);
                  setOpenReasonModal(true);
                }}
                className="p-2 border border-blue-700 text-blue-700 cursor-pointer rounded-md w-full text-center"
              >
                Skip this Step
              </p>
            </div>
          )} */}
          {fidiumCustomer?.fiberCompanyId !== 15 && (
            <img alt="Logo" src={"/images/nav/nav-logo.png"} className="logo" />
          )}
        </div>
      )}
    </Modal>
  );
};

export default ScheduleForm;
